module.exports = __webpack_public_path__ + "static/media/Charles.c53b9c8d.jpg";